import { render, staticRenderFns } from "./mGamesBetInfoAll.vue?vue&type=template&id=61c64186&scoped=true"
import script from "./mGamesBetInfoAll.vue?vue&type=script&lang=js"
export * from "./mGamesBetInfoAll.vue?vue&type=script&lang=js"
import style0 from "./mGamesBetInfoAll.vue?vue&type=style&index=0&id=61c64186&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c64186",
  null
  
)

export default component.exports